export const color = {
  _000000: '#000000',
  _3a3a3a: '#3a3a3a',
  _484848: '#484848',
  _616161: '#616161',
  _9E9E9E: '#9E9E9E',
  _DADCE0: '#DADCE0',
  _DFDFDF: '#DFDFDF',
  _EFEFEF: '#EFEFEF',
  _FFFFFF: '#FFFFFF',
  _D0D0D0: '#D0D0D0',
  _4E4E4E: '#4E4E4E',
  _B05788: '#B05788',
  _33ABDA: '#33ABDA',
  _8458CC: '#8458CC',
  _FF891C: '#FF891C',
  _0078A7: '#0078A7',
  _6A3452: '#6A3452',
  _6D1A4A: '#6D1A4A',
  _818181: '#818181',
  primary: '#0078D4',
  secondary: '#5B5FC7',
  success: '#107C10',
  warning: '#FFAA44',
  error: '#D83B01',
  info: '#0078D4',

  // Colors for iteration status
  _3b82f6: '#3b82f6', // Blue
  _9333ea: '#9333ea', // Purple
  _be4b7e: '#be4b7e', // Pink
  _64748b: '#64748b', // Slate
  _7c3956: '#7c3956', // Dark Pink
  _f59e1a: '#f59e1a', // Orange
  _facc15: '#facc15', // Yellow
  _84cc16: '#84cc16', // Lime
  _0077a3: '#0077a3', // Blue
  _14b8a6: '#14b8a6', // Teal
  _06b6d4: '#06b6d4', // Cyan
  _0ea5e9: '#0ea5e9', // Light Blue
  _8b5cf6: '#8b5cf6', // Violet
  _f97316: '#f97316', // Orange (Windsurf)
  _8a8a8a: '#8a8a8a', // Gray
  _ef4444: '#ef4444', // Red
  _b5c7e5: '#b5c7e5', // Light Blue Gray
  _888888: '#888888', // Medium Gray
  _E53935: '#E53935', // Warning Red
  _C85291: '#C85291', // Dark Pink
  _218DC0: '#218DC0', // Teal Blue
  _3A2990: '#3A2990', // Windsurf brand purple
  _C66601: '#C66601', // Copilot brand orange,
  _0E4661: '#0E4661', // Deep navy blue,
  _D6AC16: '#D6AC16', // Warning Yellow
  _1E88E5: '#1E88E5',
  _C66602: '#C66602',
  _E0E0E0: '#E0E0E0',

  // AI Report – heatmap / badge / chart colours
  _2E7D32: '#2E7D32', // Green (improved)
  _C62828: '#C62828', // Red (declined)
  _E8F5E9: '#E8F5E9', // Light green badge bg
  _FFEBEE: '#FFEBEE', // Light red badge bg
  _F5F5F5: '#F5F5F5', // Neutral cell bg
  _1976D2: '#1976D2', // Blue accent
  _880E4F: '#880E4F', // Copilot credit accent
  _A855F7: '#A855F7', // Copilot tool colour
  _BDBDBD: '#BDBDBD', // Chart line stroke
  _757575: '#757575', // Chart label fallback
  _F0F0F0: '#F0F0F0', // Divider border

  // Theme specific
  lightBackground: '#FFFFFF',
  darkBackground: '#121212',
  lightText: '#212121',
  darkText: '#F5F5F5',
}

export const BENCHMARK_SERIES_COLORS = {
  GLOBAL: color._484848,
  INTERNAL: color._9E9E9E,
} as const

export const BENCHMARK_SERIES_COLORS_DARK = {
  GLOBAL: color._9E9E9E,
  INTERNAL: color._D0D0D0,
} as const

export default color
